module.exports = __webpack_public_path__ + "img/p4.44f1e8e4.png";